function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1",
  d: "M73.411 86.939A43.47 43.47 0 1030.1 43.469 43.39 43.39 0 0073.41 86.94",
  fill: "currentColor"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2",
  d: "M12.683 186.41h119.315a9.53 9.53 0 009.53-9.53v-65.348a9.53 9.53 0 00-9.53-9.53H12.683a9.53 9.53 0 00-9.53 9.53v65.348a9.53 9.53 0 009.53 9.53",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3",
  d: "M127.874 304.961L9.062 315.907a9.53 9.53 0 00-8.615 10.364l5.995 65.073a9.53 9.53 0 0010.365 8.616l118.811-10.948a9.53 9.53 0 008.616-10.364l-5.997-65.073a9.53 9.53 0 00-10.363-8.615",
  fill: "currentColor"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 4",
  d: "M136.17 208.947L17.538 196.184a9.53 9.53 0 00-10.496 8.456L.055 269.613a9.53 9.53 0 008.456 10.495l118.63 12.763a9.53 9.53 0 0010.495-8.456l6.989-64.974a9.53 9.53 0 00-8.456-10.494",
  fill: "currentColor"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-check",
  d: "M60.725 77.27L39.46 49.806a5.14 5.14 0 010-5.979l4.623-5.978a2.782 2.782 0 014.622 0l14.331 18.507L93.72 16.734a2.782 2.782 0 014.623 0l4.623 5.978a5.14 5.14 0 010 5.979l-37.61 48.578a2.782 2.782 0 01-4.63 0z",
  fill: "#fff"
});
var SvgCenterCertified = function SvgCenterCertified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 144.679 400"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};
export default SvgCenterCertified;